import React from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { markenStandortThemeBodySelector } from '../../../modules/selectors/standort/theme';
import APSHome from './APSHome';

const LegacyHome = loadable(() => import('../../components/themes/legacy/home/LegacyHome'));
const DefaultHome = loadable(() => import('./DefaultHome'));

function HomeSelector() {
    const markenStandortThemeBody = useSelector(markenStandortThemeBodySelector);
    console.log('markenStandortThemeBody.home.componentName', markenStandortThemeBody.home.componentName);

    switch (markenStandortThemeBody.home.componentName) {
        case 'LegacyHome':
            return <LegacyHome />;
        case 'DefaultHome':
            return <DefaultHome />;
        case 'APSHome':
            return <APSHome />;
        default:
            throw new Error(`Unexpected markenStandortThemeBody, got: ${markenStandortThemeBody.home.componentName}`);
    }
}

export default HomeSelector;
